import { capitalize } from "@s-libs/micro-dash";

import { IReadingSkill } from "@/search/Langston/types/IReadingSkill";
import { IStandard } from "@/search/Langston/types/IStandard";

import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";
import { MATURITY_RANGE_VALUES } from "@/search/Langston/SearchPage/SearchPage.constants";
import { RawConceptNodeMap } from "../filters/Concepts/Concepts.interface";

import { GENERATION_GENIUS_VIDEO_PARAM } from "./FilterControls.constants";

const gradeLevelValues = LangstonParameterSchema.grade_levels.values;
const languageValues = LangstonParameterSchema.languages.values;

const LITE_STREAM_ID = "clfugywx100073569vvgvoqx3";

enum InstructionalFeatureEnum {
  decodable = "decodable",
  power_words = "power_words",
  formative = "formative",
}

const INSTRUCTIONAL_FEATURES_VALUE_TEXT_MAP: {
  [InstructionalFeatureEnum.decodable]: string;
  [InstructionalFeatureEnum.formative]: string;
  [InstructionalFeatureEnum.power_words]: string;
} = {
  decodable: "Decodables",
  formative: "Formatives",
  power_words: "Power Words",
};

export const getFilterChipText = (
  paramName: string,
  paramValue: string,
  readingSkills: IReadingSkill[],
  selectedStandards: IStandard[],
  allTagsRawData: RawConceptNodeMap,
) => {
  switch (paramName) {
    case LangstonParameterSchema.streams.key:
      return paramValue === LITE_STREAM_ID ? "Free" : "";
    case LangstonParameterSchema.article_type.key:
      return paramValue === "ARTICLE_NEWS" ? "Latest news" : "";
    case LangstonParameterSchema.instructional_features.key:
      return INSTRUCTIONAL_FEATURES_VALUE_TEXT_MAP[
        paramValue as InstructionalFeatureEnum
      ];
    case LangstonParameterSchema.grade_levels.key:
      return (
        gradeLevelValues.find(({ value }) => {
          return value === paramValue;
        })?.label || ""
      );
    case LangstonParameterSchema.standards.key: {
      const selectedStandard = selectedStandards.find(
        (standard) => standard.id === paramValue,
      );
      return selectedStandard?.name || "";
    }
    case LangstonParameterSchema.reading_skills.key: {
      const readingSkill = readingSkills.find(({ id }) => id === paramValue);
      return capitalize(readingSkill?.text || "");
    }
    case LangstonParameterSchema.topics.key: {
      const item = allTagsRawData?.[paramValue];
      return item?.data.name || "";
    }
    case LangstonParameterSchema.languages.key:
      return (
        languageValues.find(({ value }) => {
          return value === paramValue;
        })?.label || ""
      );
    case LangstonParameterSchema.content_types.key: {
      if (paramValue === GENERATION_GENIUS_VIDEO_PARAM) {
        return "Generation Genius";
      }
      return "";
    }
  }
  return paramValue;
};

export const getMaturityFilterChipValue = (searchParams: URLSearchParams) => {
  const minParam = searchParams.get(
    LangstonParameterSchema.minimum_maturity.key,
  ) as string;
  const maxParam = searchParams.get(
    LangstonParameterSchema.maximum_maturity.key,
  ) as string;
  const min = parseInt(minParam);
  const max = parseInt(maxParam);

  const minRangeAbbr =
    MATURITY_RANGE_VALUES.find((rangeObj) => rangeObj.value.includes(min))
      ?.label || "";
  const maxRangeAbbr =
    MATURITY_RANGE_VALUES.find((rangeObj) => rangeObj.value.includes(max))
      ?.label || "";

  if (minRangeAbbr === maxRangeAbbr) {
    return minRangeAbbr;
  }

  return `${minRangeAbbr} - ${maxRangeAbbr}`;
};
